import { CashDetail } from "../CashDetail";

export class FitnessStatisticsTotals {
    public totInFit: CashDetail[] = [];
    public totInUnfit: CashDetail[] = [];
    public totOut: CashDetail[] = [];

    public parse(obj: any) {
        if (obj.TotInFit && obj.TotInFit.length > 0) {
            obj.TotInFit.forEach((cashDetailToParse) => {
                var cashDetail: CashDetail = new CashDetail();
                cashDetail.parse(cashDetailToParse);
                this.totInFit.push(cashDetail);
            });
        }

        if (obj.TotInUnfit && obj.TotInUnfit.length > 0) {
            obj.TotInUnfit.forEach((cashDetailToParse) => {
                var cashDetail: CashDetail = new CashDetail();
                cashDetail.parse(cashDetailToParse);
                this.totInUnfit.push(cashDetail);
            });
        }

        if (obj.TotOut && obj.TotOut.length > 0) {
            obj.TotOut.forEach((cashDetailToParse) => {
                var cashDetail: CashDetail = new CashDetail();
                cashDetail.parse(cashDetailToParse);
                this.totOut.push(cashDetail);
            });
        }
    }

    public sum(totInFit: CashDetail[], totInUnfit: CashDetail[], totOut: CashDetail[]) {
        totInFit.forEach((cashDetail) => {
            if (this.totInFit.find((cd) => cd.denomination.isEquals(cashDetail.denomination)))
                this.totInFit.find((cd) => cd.denomination.isEquals(cashDetail.denomination)).quantity += cashDetail.quantity;
            else this.totInFit.push(cashDetail);
        });

        totInUnfit.forEach((cashDetail) => {
            if (this.totInUnfit.find((cd) => cd.denomination.isEquals(cashDetail.denomination)))
                this.totInUnfit.find((cd) => cd.denomination.isEquals(cashDetail.denomination)).quantity += cashDetail.quantity;
            else this.totInUnfit.push(cashDetail);
        });

        totOut.forEach((cashDetail) => {
            if (this.totOut.find((cd) => cd.denomination.isEquals(cashDetail.denomination)))
                this.totOut.find((cd) => cd.denomination.isEquals(cashDetail.denomination)).quantity += cashDetail.quantity;
            else this.totOut.push(cashDetail);
        });
    }

    public sumFitnessStatisticsTotals(fitnessStatisticsTotals: FitnessStatisticsTotals) {
        this.sum(fitnessStatisticsTotals.totInFit, fitnessStatisticsTotals.totInUnfit, fitnessStatisticsTotals.totOut);
    }
}
